import { useAppConfig } from '@landr/mfe';

const SamplesBrand = 'Samples';
const CreatorBrand = 'Creator';
const SelectorBrand = 'Selector';
const QuicksPicksBrand = 'Quick Picks';

export const useDynamicBranding = () => {
    const appConfig = useAppConfig();
    const { name } = appConfig;
    const { longName } = appConfig.branding;
    const formattedLongName = name === 'Unknown' ? 'LANDR' : longName;

    return {
        name: formattedLongName,
        samplesBrand: SamplesBrand,
        samplesWithName: `${formattedLongName} ${SamplesBrand}`,
        creatorBrand: CreatorBrand,
        selectorBrand: SelectorBrand,
        quicksPicksBrand: QuicksPicksBrand,
    };
};
